// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactModal from "react-modal";
import * as AuthConfig$PorterinFeature from "../../../login/domain/config/AuthConfig.mjs";
import * as PnmModalModuleScss from "../styles/PnmModal.module.scss";
import * as PaymentFailureCmp$PorterinFeature from "./Payment-failure/components/PaymentFailureCmp.mjs";
import * as PaymentSuccessCmp$PorterinFeature from "./payment-success/components/PaymentSuccessCmp.mjs";

var styles = PnmModalModuleScss;

function PaymentStatusModalCmp(Props) {
  var modal_state = Props.modal_state;
  var close_modal = Props.close_modal;
  var payment_status = Props.payment_status;
  var booking_flow = Props.booking_flow;
  return React.createElement(ReactModal, {
              isOpen: modal_state,
              onRequestClose: close_modal,
              closeTimeoutMS: AuthConfig$PorterinFeature.modal_close_timeout,
              overlayClassName: styles.overlay,
              className: "" + styles["modal-container"] + "",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: payment_status ? React.createElement(PaymentFailureCmp$PorterinFeature.make, {
                      payment_amount: payment_status._0,
                      close_modal: close_modal
                    }) : (
                  booking_flow ? null : React.createElement(PaymentSuccessCmp$PorterinFeature.make, {})
                )
            });
}

var make = PaymentStatusModalCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
